import TrendIcon from '@skyscanner/backpack-web/bpk-component-icon/lg/trend';
import TrendDownIcon from '@skyscanner/backpack-web/bpk-component-icon/lg/trend--down';
import TrendSteadyIcon from '@skyscanner/backpack-web/bpk-component-icon/lg/trend--steady';

import type { PriceLevel } from '@shared/types/frontend/ubff/price-band';

type Props = {
  type: PriceLevel;
};

const PriceBannerTrendIcon = ({ type }: Props) => {
  if (type === 'PRICE_LEVEL_HIGH') {
    return <TrendIcon />;
  }

  if (type === 'PRICE_LEVEL_LOW') {
    return <TrendDownIcon />;
  }

  return <TrendSteadyIcon />;
};

export default PriceBannerTrendIcon;
